import React, { createContext, useContext, useState } from 'react';

// App-lifetime memory only. This owner allocates no private runtime or requests.
const Context = createContext(null);
export function ChatRecoveryProvider({ children }) {
  const [store] = useState(() => {
    let owner;
    const conversations = new Map();
    return {
      forOwner(nextOwner) {
        // Account/session changes (including logout) discard the former owner's drafts.
        if (owner !== nextOwner) { conversations.clear(); owner = nextOwner; }
        return conversations;
      },
    };
  });
  return <Context.Provider value={store}>{children}</Context.Provider>;
}
export const useChatRecovery = () => useContext(Context);
